import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2025 from '../SchoolProgram2023/components/Sidebar2025';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const PromotingMentalandWell2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/promoting-mental-health-and-well-being/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/promoting-mental-health-and-well-being/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/promoting-mental-health-and-well-being/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/promoting-mental-health-and-well-being/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/promoting-mental-health-and-well-being/5.webp`;
     const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/promoting-mental-health-and-well-being/6.webp`;






    const photos = [
       
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
         {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
         {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
        
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                              CBT Workshop
Promoting Mental Health and Wellbeing among Students
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                  Date: Tuesday, 19 May 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                               <Typography variant={'subtitle1'} align={'justify'}>
National Public School, Yeshwanthpur has always been at the forefront of empowering teachers through meaningful workshops and training programmes that enhance their professional skills and strengthen student support systems.
 It was conducted by CBSE Resource persons Ms Anupa Sreedhar and Ms Roja S Manuballa.
  <br></br>

A CBSE Capacity Building Programme Workshop on ‘Promoting Mental Health and Wellbeing among Students’
 was conducted for teachers of Classes VI to XII to enhance awareness about students’ emotional and psychological
  needs. The workshop covered common emotional and behavioural issues in children, probable mental health aberrations and their symptoms and practical strategies teachers can use to support students empathetically. Emphasis was given to creating a safe and supportive school environment and encouraging students to seek help when needed. It was strongly reiterated that diagnosis and treatment must always be left to trained mental
 health professionals and that such terms should never be used casually or carelessly by teachers or others. 

  <br></br>
The workshop was highly informative and beneficial for all the participants. The workshop was conducted through interactive activities, case studies and role plays that encouraged teachers to reflect on the emotional needs of their students, their own wellbeing and their families. The sessions inspired teachers to adopt more compassionate and
 sensitive approaches in addressing the emotional and behavioural concerns of students within the school environment.
  <br></br>

</Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
             ‘You cannot pour from an empty cup’
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default PromotingMentalandWell2026;